import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APITypeLogin {


  getUrlDomain(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = location.protocol + "//" + location.hostname + "/";

    }

    return result + nome_metodo;


  }

  async saveTypeLogin(type_login, user, v_id) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("v_id", v_id);

    for (var key in type_login) {
      formData.append(key, type_login[key]);
    }


    return axios.post(this.getUrlDomain("saveTypeLogin"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  async goSaveTypeLogin(type_login, user, v_id) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("v_id", v_id);

    for (var key in type_login) {
      formData.append(key, type_login[key]);
    }


    return axios.post(this.getUrlDomain("goSaveTypeLogin"), formData, { 'Content-Type': 'multipart/form-data' });

  }





  async editTypeLogin(v_id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("v_id", v_id);

    return axios.post(this.getUrlDomain("editTypeLogin"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  // async deleteTypeLogin(v_id, user) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("v_id", v_id);

  //   return axios.post(this.getUrlDomain("deleteTypeLogin"), formData, { 'Content-Type': 'multipart/form-data' });

  // }

  async deleteTypeLogin(v_id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("v_id", v_id);

    return axios.post(this.getUrlDomain("goDeleteTypeLogin"), formData, { 'Content-Type': 'multipart/form-data' });

  }


}

export default new APITypeLogin({
  url: "https://services.ebadge.it/public/api/"
})
